<template>
  <modal title="Are you sure?" @close="$emit('close')" :show-close-button="false" class="modal__warning">
    <p>Do you really want to reactivate your subscription?</p>
    <template v-slot:footer>
      <v-button class="btn btn-primary modal__button" @click="cb" group="subscribe">Yes, I am sure</v-button>
      <button class="btn btn-cancel modal__button" @click="$emit('close')">No, keep my subscription inactive</button>
    </template>
  </modal>
</template>

<script>
import Modal from '@/components/utils/Modal';
import Button from '@/components/utils/Button';

export default {
  name: 'reactivate-subscription-modal',
  components: {
    Modal,
    'v-button': Button,
  },
  props: {
    cb: {
      required: true,
      type: Function,
    },
  },
};
</script>
